export { default } from './AvatarIcon'
